import { useState } from "react";
import { useNavigate } from "react-router-dom";
import petConnectLogo from "./assets/images/petConnectLogoNoBG.png";

const Register = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [maxProfiles, setMaxProfiles] = useState("")
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [accessCode, setAccessCode] = useState("")



    const navigate = useNavigate();

    const handleRegister = async (e) => {
        e.preventDefault();

        // Validate access code
        if (accessCode !== "admin") {
            alert("Código de acceso inválido");
            return;
        }


        setLoading(true);
        setError(null);

        try {
            const response = await fetch(
                "https://create-user-pet-867228903962.us-central1.run.app",
                {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        email,
                        password,
                        maxProfiles: Number(1), // Convert to number, fallback to 0
                        // maxProfiles: Number(maxProfiles), 
                        profileCount: Number(0),
                    }),
                }
            );

            if (!response.ok) {
                throw new Error("Error al crear la cuenta. Intentá de nuevo.");
            }

            alert("Cuenta creada con éxito. Inicia sesión.");
            navigate("/login"); // Redirect back to login after successful registration
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="login-form">
            <div className="hero-image" onClick={() => navigate("/")}>
                <img src={petConnectLogo} alt="Código QR para Mascotas" />
            </div>

            <h2>Crear Cuenta</h2>
            {error && <p style={{ color: "red" }}>{error}</p>}
            <form onSubmit={handleRegister}>
                <div>
                    <label>Email:</label>
                    <input
                        type="email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    />
                </div>
                <div>
                    <label>Contraseña:</label>
                    <input
                        type="password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                    />
                </div>
                {/* <div>
                    <label>Número de perfiles:</label>
                    <input
                        type="text"
                        value={maxProfiles}
                        // onChange={(e) => setMaxProfiles(e.target.value)}
                        onChange={(e) => setMaxProfiles(Number(e.target.value))} // Convert to number
min={1}
                        
                        required
                      
                    />
                </div> */}
                <div>
                    <label>Código de acceso:</label>
                    <input
                        type="text"
                        value={accessCode}
                        onChange={(e) => setAccessCode(e.target.value)}
                        required
                    />
                </div>
                <button type="submit" disabled={loading}>
                    {loading ? "Creando cuenta..." : "Crear cuenta"}
                </button>
                <button type="button" onClick={() => navigate("/login")}>
                    Volver al inicio de sesión
                </button>
            </form>
        </div>
    );
};

export default Register;
